/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdShareholders200Ok
 */
export interface GetCorporationsCorporationIdShareholders200Ok {
    /**
     * share_count integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdShareholders200Ok
     */
    shareCount: number;
    /**
     * shareholder_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdShareholders200Ok
     */
    shareholderId: number;
    /**
     * shareholder_type string
     * @type {string}
     * @memberof GetCorporationsCorporationIdShareholders200Ok
     */
    shareholderType: GetCorporationsCorporationIdShareholders200OkShareholderTypeEnum;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdShareholders200OkShareholderTypeEnum = {
    Character: 'character',
    Corporation: 'corporation'
} as const;
export type GetCorporationsCorporationIdShareholders200OkShareholderTypeEnum = typeof GetCorporationsCorporationIdShareholders200OkShareholderTypeEnum[keyof typeof GetCorporationsCorporationIdShareholders200OkShareholderTypeEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdShareholders200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdShareholders200Ok(value: object): value is GetCorporationsCorporationIdShareholders200Ok {
    if (!('shareCount' in value) || value['shareCount'] === undefined) return false;
    if (!('shareholderId' in value) || value['shareholderId'] === undefined) return false;
    if (!('shareholderType' in value) || value['shareholderType'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdShareholders200OkFromJSON(json: any): GetCorporationsCorporationIdShareholders200Ok {
    return GetCorporationsCorporationIdShareholders200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdShareholders200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdShareholders200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'shareCount': json['share_count'],
        'shareholderId': json['shareholder_id'],
        'shareholderType': json['shareholder_type'],
    };
}

export function GetCorporationsCorporationIdShareholders200OkToJSON(json: any): GetCorporationsCorporationIdShareholders200Ok {
    return GetCorporationsCorporationIdShareholders200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdShareholders200OkToJSONTyped(value?: GetCorporationsCorporationIdShareholders200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'share_count': value['shareCount'],
        'shareholder_id': value['shareholderId'],
        'shareholder_type': value['shareholderType'],
    };
}

